import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row, Col, NavItem, Nav, Card } from "reactstrap";
import Link from "next/link";
import styles from "./styles.module.scss";
import Arrow from "/public/site-assets/svg/black-arrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import LinkedIn from "/public/site-assets/svg/linkedin.svg";
import Mail from "/public/site-assets/svg/mail.svg";
import Phone from "/public/site-assets/svg/telephone.svg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import useTeam from "hooks/useTeam";

export const ConsultantCarousel = ({
  className,
  title,
  heading,
  content,
  team, // Array of team member IDs
  swiperID = "team-swiper",
}) => {
  const allTeams = useTeam();

  // Filter allTeams to only include the members present in team array
  const filteredTeam = allTeams.filter((member) => team.includes(member.id)) ?? allTeams;

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .${swiperID}`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };
  return (
    <section className={`${styles.root} ${className} grayGradientBg`}>
      <Container>
        <div className="text-center">
          {title &&
            <h3 className={`${heading} mb-1`}>{title}</h3>
          }
          {content &&
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          }
        </div>
        <div className="pt-5 position-relative">
          <div className="d-flex position-absolute swiperArrowWrapper">
            <button
              className={`${swiperID} arrow swiper-prev border-0 p-0`}
              aria-label="Prev"
            >
              <Arrow />
            </button>
            <button
              className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`}
              aria-label="Next"
            >
              <Arrow />
            </button>
          </div>
          <Swiper {...settings}>
            {filteredTeam?.map((post, index) => (
              <SwiperSlide key={index}>
                <Card className="bg-transparent border-0">
                  <button
                    className="fancyBox rounded-5 overflow-hidden h-100 d-block border-0 p-0"
                    data-src={`#${post.id}-content`}
                  >
                    <SourceFlowImage
                      src={
                        post?.image
                          ? post.image
                          : "/site-assets/placeholders/img-placeholder.jpg"
                      }
                      size="1000x1000"
                      alt={post?.title}
                      className="card-img rounded-0 h-100"
                    />
                  </button>
                  <div className="p-3">
                    <p className="post-title fs-5 mb-0">
                      <strong>{post?.title}</strong>
                    </p>
                    <p className="post-position">{post?.position}</p>
                    <Nav className="d-flex contacts mt-2">
                      {post.email ? (
                        <NavItem className="position-relative">
                          <Link href={`mailto:${post?.email}`}>
                            <a className="text-decoration-none" title="Mail">
                              <Mail />
                            </a>
                          </Link>
                        </NavItem>
                      ) : null}
                      {post.telephone ? (
                        <NavItem className="position-relative">
                          <Link href={`tel:${post?.telephone}`}>
                            <a
                              className="text-decoration-none"
                              title="Telephone"
                            >
                              <Phone />
                            </a>
                          </Link>
                        </NavItem>
                      ) : null}
                      {post.linkedin ? (
                        <NavItem className="position-relative">
                          <Link href={`${post?.linkedin}`}>
                            <a
                              className="text-decoration-none"
                              target="_blank"
                              rel="noopener noreferrer"
                              title="LinkedIn"
                            >
                              <LinkedIn />
                            </a>
                          </Link>
                        </NavItem>
                      ) : null}
                    </Nav>
                  </div>
                  {post?.content ? (
                    <div
                      id={`${post.id}-content`}
                      className="consultant-pop-content p-0 rounded-4"
                    >
                      <Row className="">
                        <Col md={4}>
                          <SourceFlowImage
                            src={
                              post?.image
                                ? post.image
                                : "/site-assets/placeholders/img-placeholder.jpg"
                            }
                            size="x1000"
                            alt={post?.title}
                            className="card-img rounded-4 h-100"
                          />
                        </Col>
                        <Col md={8} className="p-4 p-md-5">
                          <p className="post-title fs-5 mb-0">
                            <strong>{post?.title}</strong>
                          </p>
                          <p className="post-position">{post?.position}</p>
                          <Nav className="d-flex contacts mt-2">
                            {post.email ? (
                              <NavItem className="position-relative">
                                <Link href={`mailto:${post?.email}`}>
                                  <a
                                    className="text-decoration-none"
                                    title="Mail"
                                  >
                                    <Mail />
                                  </a>
                                </Link>
                              </NavItem>
                            ) : null}
                            {post.telephone ? (
                              <NavItem className="position-relative">
                                <Link href={`tel:${post?.telephone}`}>
                                  <a
                                    className="text-decoration-none"
                                    title="Telephone"
                                  >
                                    <Phone />
                                  </a>
                                </Link>
                              </NavItem>
                            ) : null}
                            {post.linkedin ? (
                              <NavItem className="position-relative">
                                <Link href={`${post?.linkedin}`}>
                                  <a
                                    className="text-decoration-none"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="LinkedIn"
                                  >
                                    <LinkedIn />
                                  </a>
                                </Link>
                              </NavItem>
                            ) : null}
                          </Nav>
                          {post?.content ? (
                            <div
                              className="post-content mt-5"
                              dangerouslySetInnerHTML={{
                                __html: post?.content,
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>
                  ) : null}
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="text-center swiper-custom-paginations mt-4">
          <div className={`${swiperID}`} />
        </div>
      </Container>
    </section>
  );
}

export default ConsultantCarousel;
